module.exports = __webpack_public_path__ + "img/logo-retail.bb66b29f.png";